import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { enrollmentAPI, certificateAPI, courseAPI } from '../../services/api';
import { LoadingSpinner } from '../../components/UI';
import { useAuth } from '../../context/AuthContext';

const UserDashboard = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const [enrollments, certs, courses] = await Promise.all([
          enrollmentAPI.mine(),
          certificateAPI.mine(),
          courseAPI.list(),
        ]);
        setStats({
          enrollments: enrollments.data,
          certificates: certs.data,
          availableCourses: courses.data.length,
          recent: enrollments.data.slice(0, 3),
        });
      } catch (e) { console.error(e); }
    })();
  }, []);

  if (!stats) return <LoadingSpinner />;

  const approved = stats.enrollments.filter((e) => e.status === 'approved').length;
  const completed = stats.enrollments.filter((e) => e.status === 'completed').length;

  return (
    <div className="container">
      <div className="page-header">
        <div>
          <h1>Hello, {user?.name?.split(' ')[0]} 👋</h1>
          <p className="subtitle">Pick up where you left off</p>
        </div>
        <Link to="/courses" className="btn btn-primary">Browse courses →</Link>
      </div>

      <div className="grid grid-4">
        <div className="stat-card">
          <div className="accent-bar"></div>
          <div className="label">Enrolled</div>
          <div className="value">{stats.enrollments.length}</div>
        </div>
        <div className="stat-card">
          <div className="accent-bar" style={{ background: 'var(--accent)' }}></div>
          <div className="label">In Progress</div>
          <div className="value">{approved}</div>
        </div>
        <div className="stat-card">
          <div className="accent-bar" style={{ background: 'var(--success)' }}></div>
          <div className="label">Completed</div>
          <div className="value">{completed}</div>
        </div>
        <div className="stat-card">
          <div className="accent-bar" style={{ background: 'var(--warning)' }}></div>
          <div className="label">Certificates</div>
          <div className="value">{stats.certificates.length}</div>
        </div>
      </div>

      <div className="mt-3">
        <div className="flex justify-between items-center mb-2">
          <h3>Recent enrollments</h3>
          <Link to="/my-courses" className="btn btn-secondary btn-sm">See all</Link>
        </div>
        {stats.recent.length === 0 ? (
          <div className="card text-center">
            <p>No enrollments yet.</p>
            <Link to="/courses" className="btn btn-primary mt-2">Find a course</Link>
          </div>
        ) : (
          <div className="grid grid-3">
            {stats.recent.map((e) => (
              <div key={e._id} className="course-card">
                <div className="thumb">{e.course?.title?.charAt(0)}</div>
                <div className="body">
                  <span className="category">{e.course?.category}</span>
                  <h3>{e.course?.title}</h3>
                  <span className={`badge badge-${e.status}`}>{e.status}</span>
                  <div className="progress mt-2"><div className="progress-bar" style={{ width: `${e.progress}%` }}></div></div>
                  <small className="text-muted">{e.progress}% complete</small>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default UserDashboard;
